// EXPERIMENT #171270395

import React from 'react';
import PropTypes from 'prop-types';
import GoogleSignupCta from 'components/signup_modal/google_signup_cta';
import LeadFormWithPassword from './lead_form_with_password';
import CompanyLeadShape from '../constants/CompanyLeadShape';

const Header = () => (
  <>
    <h1 className="col-12 text-center h4">Great! Let&apos;s get you set up.</h1>
  </>
);

const LpHeader = () => (
  <>
    <div className="col-12 text-center text-large padding-bottom-10px">
      <span className="text-large-bold">Nice!</span> We could be a great fit for your business.
    </div>
  </>
);

const Divider = () => (
  <div className="padding-bottom-10px padding-top-10px">
    <div className="google-signup-or text-center overflow-hidden">
      <span>or</span>
    </div>
  </div>
);

const Terms = () => (
  <div className="text-small c-black-900">
    By creating an account, you agree to the{' '}
    <a href="/about/terms" target="_blank">
      terms & conditions
    </a>
    , the{' '}
    <a href="/about/terms/payroll" target="_blank">
      payroll terms
    </a>
    , and our{' '}
    <a href="/about/privacy" target="_blank">
      privacy policy
    </a>
    .
  </div>
);

const Footer = () => (
  <>
    <div className="margin-bottom-15px">
      Already use Gusto? <a href={window.loginBaseUrl}>Sign in here</a>.
    </div>
    <Terms />
  </>
);

const SignupForm = ({ contractorOnly, fromGoogleSSO, companyLead, isLP }) => {
  return (
    <div className="survey-signup-form row">
      {isLP ? <LpHeader /> : <Header />}

      <div className="d-flex flex-column justify-content-between col-12">
        <div className="padding-top-10px width-100">
          {!fromGoogleSSO && (
            <div>
              <GoogleSignupCta
                googleSignupBaseUrl="/google_sso/homepage_survey_signup/new"
                googleButtonLabel="Sign up with Google"
              />
              <Divider />
            </div>
          )}
          <LeadFormWithPassword
            contractorOnly={contractorOnly}
            companyLead={companyLead}
            fromGoogleSSO={fromGoogleSSO}
          />
          <div className="d-block margin-top-25px">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

SignupForm.propTypes = {
  contractorOnly: PropTypes.bool.isRequired,
  fromGoogleSSO: PropTypes.bool.isRequired,
  companyLead: CompanyLeadShape.isRequired,
  isLP: PropTypes.bool,
};

SignupForm.defaultProps = {
  isLP: false,
};

export { SignupForm, Footer };
